import { LoggerFactory as Q } from "@videoblocks/typescript-logger";
class V {
  constructor(e) {
    this.config = e, this.baseLogger = Q.create("StructuredData");
  }
  debug(e, t) {
    this.config.enabled && this.config.level === "debug" && (t ? this.baseLogger.debug(t, e) : this.baseLogger.debug(e));
  }
  info(e, t) {
    this.config.enabled && ["debug", "info"].includes(this.config.level) && (t ? this.baseLogger.info(t, e) : this.baseLogger.info(e));
  }
  warn(e, t) {
    this.config.enabled && ["debug", "info", "warn"].includes(this.config.level) && (t ? this.baseLogger.warn(t, e) : this.baseLogger.warn(e));
  }
  error(e, t) {
    this.config.enabled && (t ? this.baseLogger.error(t, e) : this.baseLogger.error(e));
  }
  /**
   * Update the logger configuration
   */
  updateConfig(e) {
    this.config = e;
  }
}
const M = new V({
  enabled: !1,
  level: "info"
}), P = (i) => {
  M.updateConfig(i);
}, l = M, k = {
  storyblocks: {
    baseUrl: "https://www.storyblocks.com",
    organizationId: "https://www.storyblocks.com/#organization",
    logo: {
      url: "https://cdn.builder.io/api/v1/image/assets%2Fe7fb3d1e4da14573bd2a1edb7bfee5f1%2F8977452afd404719a1cfac9521c44586",
      width: "200px",
      height: "50px"
    },
    social: {
      facebook: "https://www.facebook.com/storyblocks/",
      twitter: "https://twitter.com/StoryblocksCo",
      linkedin: "https://www.linkedin.com/company/storyblocks/",
      youtube: "https://www.youtube.com/channel/UCrxwwZTQOPCTUVlHsjNU7Fw",
      instagram: "https://www.instagram.com/StoryblocksCo/"
    },
    endpoints: {
      pricing: "/pricing",
      support: "/support",
      video: "/video"
    },
    contact: {
      email: "support@storyblocks.com",
      phone: "+1-800-555-0123",
      supportPhone: "+1-800-SUPPORT",
      salesPhone: "+1-800-SALES-01",
      faxNumber: void 0,
      contactType: "Customer Service",
      areaServed: "Worldwide",
      availableLanguages: ["English", "Spanish"],
      hoursAvailable: {
        "@type": "OpeningHoursSpecification",
        opens: "09:00",
        closes: "17:00",
        dayOfWeek: [
          "https://schema.org/Monday",
          "https://schema.org/Tuesday",
          "https://schema.org/Wednesday",
          "https://schema.org/Thursday",
          "https://schema.org/Friday"
        ]
      }
    },
    website: {
      searchUrl: "/search",
      searchQueryParam: "q"
    },
    legal: {
      privacyPolicyUrl: "/privacy-policy",
      termsOfServiceUrl: "/terms-of-service",
      copyrightYear: (/* @__PURE__ */ new Date()).getFullYear(),
      copyrightHolder: "Storyblocks",
      jurisdiction: "United States",
      licenseName: void 0,
      licenseUrl: void 0
    },
    navigation: {
      mainMenuItems: [
        { name: "Home", url: "/", position: 1 },
        { name: "Video", url: "/video", position: 2 },
        { name: "Audio", url: "/audio", position: 3 },
        { name: "Images", url: "/images", position: 4 },
        { name: "Pricing", url: "/pricing", position: 5 }
      ],
      footerLinks: [
        { name: "About Us", url: "/about", section: "company" },
        { name: "Careers", url: "/careers", section: "company" },
        { name: "Press", url: "/press", section: "company" },
        { name: "Privacy Policy", url: "/privacy-policy", section: "legal" },
        { name: "Terms of Service", url: "/terms-of-service", section: "legal" },
        { name: "Cookie Policy", url: "/cookie-policy", section: "legal" },
        { name: "Help Center", url: "/support", section: "support" },
        { name: "Contact Us", url: "/contact", section: "support" }
      ]
    }
  },
  cache: {
    maxVideoEntries: 1e3,
    maxDurationEntries: 500,
    ttl: void 0
  },
  validation: {
    maxRating: 5,
    minRating: 1,
    currencyCodeLength: 3
  },
  logging: {
    enabled: !1,
    level: "info"
  }
};
class Y {
  constructor() {
    this._config = { ...k }, this.configProxy = this.createReactiveConfig(this._config), P(this._config.logging);
  }
  createReactiveConfig(e) {
    return new Proxy(e, {
      set(t, r, s) {
        const a = Reflect.set(t, r, s);
        return r === "logging" && s !== t[r] && P(s), a;
      },
      get(t, r) {
        const s = Reflect.get(t, r);
        return r === "logging" && typeof s == "object" && s !== null ? new Proxy(s, {
          set(a, n, d) {
            const f = Reflect.set(a, n, d);
            return P(d), f;
          }
        }) : s;
      }
    });
  }
  getConfig() {
    return this.configProxy;
  }
  updateConfig(e) {
    this._config = this.deepMerge(this._config, e), this.configProxy = this.createReactiveConfig(this._config), e.logging && P(this._config.logging);
  }
  resetConfig() {
    this._config = { ...k }, this.configProxy = this.createReactiveConfig(this._config), P(this._config.logging);
  }
  getOrganizationSchema() {
    const { storyblocks: e } = this._config;
    return {
      "@type": "Organization",
      "@id": e.organizationId,
      name: "Storyblocks",
      url: e.baseUrl,
      logo: {
        "@type": "ImageObject",
        url: e.logo.url,
        width: e.logo.width,
        height: e.logo.height
      },
      sameAs: Object.values(e.social)
    };
  }
  getWebsiteSchema() {
    const { storyblocks: e } = this._config, t = {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${e.baseUrl}${e.website.searchUrl}?${e.website.searchQueryParam}={search_term_string}`
      },
      query: "required name=search_term_string"
    };
    return {
      "@type": "WebSite",
      "@context": "https://schema.org",
      name: "Storyblocks",
      url: e.baseUrl,
      publisher: this.getOrganizationSchema(),
      potentialAction: t,
      sameAs: Object.values(e.social).filter(Boolean)
    };
  }
  getEnhancedWebsiteSchema() {
    const { storyblocks: e } = this._config, t = {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${e.baseUrl}${e.website.searchUrl}?${e.website.searchQueryParam}={search_term_string}`
      },
      query: "required name=search_term_string"
    };
    return {
      "@type": "WebSite",
      "@id": `${e.baseUrl}/#website`,
      url: e.baseUrl,
      name: "Storyblocks",
      publisher: this.getOrganizationSchema(),
      potentialAction: t
    };
  }
  getContactPointSchema() {
    const { storyblocks: e } = this._config;
    return {
      "@type": "ContactPoint",
      email: e.contact.email,
      telephone: e.contact.phone,
      contactType: e.contact.contactType,
      areaServed: e.contact.areaServed,
      availableLanguage: e.contact.availableLanguages,
      hoursAvailable: e.contact.hoursAvailable
    };
  }
  getPublisherReference() {
    return this._config.storyblocks.organizationId;
  }
  buildUrl(e) {
    const { baseUrl: t } = this._config.storyblocks, r = t.replace(/\/$/, ""), s = e.startsWith("/") ? e : `/${e}`;
    return `${r}${s}`;
  }
  deepMerge(e, t) {
    const r = {
      ...e,
      ...t,
      cache: t.cache ? { ...e.cache, ...t.cache } : e.cache,
      validation: t.validation ? { ...e.validation, ...t.validation } : e.validation,
      logging: t.logging ? { ...e.logging, ...t.logging } : e.logging
    };
    if (t.storyblocks) {
      const s = t.storyblocks;
      r.storyblocks = {
        ...e.storyblocks,
        ...s,
        logo: s.logo ? { ...e.storyblocks.logo, ...s.logo } : e.storyblocks.logo,
        social: s.social ? { ...e.storyblocks.social, ...s.social } : e.storyblocks.social,
        endpoints: s.endpoints ? { ...e.storyblocks.endpoints, ...s.endpoints } : e.storyblocks.endpoints,
        contact: s.contact ? { ...e.storyblocks.contact, ...s.contact } : e.storyblocks.contact,
        website: s.website ? { ...e.storyblocks.website, ...s.website } : e.storyblocks.website,
        legal: s.legal ? { ...e.storyblocks.legal, ...s.legal } : e.storyblocks.legal,
        navigation: s.navigation ? { ...e.storyblocks.navigation, ...s.navigation } : e.storyblocks.navigation
      };
    }
    return r;
  }
}
const h = new Y(), Te = (i) => h.updateConfig(i), xe = () => h.resetConfig();
class U {
  constructor(e = {}) {
    this.cache = /* @__PURE__ */ new Map(), this.maxEntries = e.maxEntries ?? 1e3, this.ttl = e.ttl ?? null;
  }
  /**
   * Get a value from cache or generate it using the provided function
   */
  get(e, t) {
    const r = this.cache.get(e);
    if (r)
      if (this.ttl && Date.now() - r.timestamp > this.ttl)
        this.cache.delete(e);
      else
        return this.cache.delete(e), this.cache.set(e, r), r.value;
    if (t) {
      const s = t();
      return this.set(e, s), s;
    }
  }
  /**
   * Set a value in the cache
   */
  set(e, t) {
    if (this.cache.size >= this.maxEntries && !this.cache.has(e)) {
      const r = this.cache.keys().next().value;
      r !== void 0 && this.cache.delete(r);
    }
    this.cache.set(e, {
      value: t,
      timestamp: Date.now()
    });
  }
  /**
   * Check if a key exists in the cache
   */
  has(e) {
    const t = this.cache.get(e);
    return t ? this.ttl && Date.now() - t.timestamp > this.ttl ? (this.cache.delete(e), !1) : !0 : !1;
  }
  /**
   * Clear all entries from the cache
   */
  clear() {
    this.cache.clear();
  }
  /**
   * Get the current size of the cache
   */
  get size() {
    return this.cache.size;
  }
  /**
   * Get cache statistics
   */
  getStats() {
    return {
      size: this.cache.size,
      maxEntries: this.maxEntries,
      fillRate: this.cache.size / this.maxEntries
    };
  }
}
class J extends U {
  constructor() {
    super({ maxEntries: 500 });
  }
  /**
   * Convert seconds to ISO 8601 duration format with caching
   */
  convertToIsoDuration(e) {
    return this.get(e, () => {
      const t = Math.floor(e / 3600), r = Math.floor(e % 3600 / 60), s = Math.floor(e % 60);
      let a = "PT";
      return t > 0 && (a += `${t}H`), r > 0 && (a += `${r}M`), s > 0 && (a += `${s}S`), a === "PT" ? "PT0S" : a;
    }) ?? "PT0S";
  }
}
function g(i) {
  return { success: !0, data: i };
}
function c(i) {
  return { success: !1, error: i };
}
function m(i) {
  return i.success === !0;
}
function y(i, e = 0) {
  if (typeof i == "number" && !isNaN(i))
    return i;
  const t = Number(i);
  return isNaN(t) ? e : t;
}
function o(i, e = "") {
  return typeof i == "string" ? i : i == null ? e : String(i);
}
function S(i) {
  try {
    return new URL(i), !0;
  } catch {
    return !1;
  }
}
function G(i) {
  return i ? i.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&nbsp;/g, " ") : "";
}
function u(i) {
  if (!i || typeof i != "string") return "";
  const e = i.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "").replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "").replace(/<[^>]*>/g, "").trim();
  return G(e);
}
function p(i, e = "https://www.storyblocks.com") {
  if (!i) return "";
  if (i.startsWith("http://") || i.startsWith("https://"))
    return i;
  const t = e.replace(/\/$/, ""), r = i.startsWith("/") ? i : `/${i}`;
  return `${t}${r}`;
}
function K(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "item", message: "Item must be an object" }]);
  const t = i;
  t.id || e.push({ field: "id", message: "Video ID is required" }), t.title || e.push({ field: "title", message: "Video title is required" });
  const r = ["thumbnailUrl", "previewUrl", "detailsUrl", "mediumImageUrl", "largeImageUrl"];
  for (const a of r) {
    const n = t[a];
    n && typeof n == "string" && !S(p(n)) && e.push({
      field: a,
      message: "Invalid URL format",
      value: n
    });
  }
  const s = [
    "duration",
    "maxResolution",
    "aspectRatio",
    "fileSize",
    "bitrate",
    "rating",
    "ratingCount",
    "viewCount",
    "downloadCount"
  ];
  for (const a of s) {
    const n = t[a];
    if (n !== void 0 && typeof n != "number") {
      const d = Number(n);
      isNaN(d) && e.push({
        field: a,
        message: "Must be a valid number",
        value: n
      });
    }
  }
  if (t.rating !== void 0) {
    const a = y(t.rating);
    (a < 0 || a > 5) && e.push({
      field: "rating",
      message: "Rating must be between 0 and 5",
      value: a
    });
  }
  return e.length > 0 ? c(e) : g(t);
}
function E(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "item", message: "Item must be an object" }]);
  const t = i;
  t.title || e.push({ field: "title", message: "Title is required" });
  const r = ["image", "url"];
  for (const s of r) {
    const a = t[s];
    a && typeof a == "string" && !S(p(a)) && e.push({
      field: s,
      message: "Invalid URL format",
      value: a
    });
  }
  if (t.price !== void 0) {
    const s = Number(t.price);
    (isNaN(s) || s < 0) && e.push({
      field: "price",
      message: "Price must be a positive number",
      value: t.price
    });
  }
  return t.currency && typeof t.currency == "string" && t.currency.length !== 3 && e.push({
    field: "currency",
    message: "Currency must be a 3-letter code (e.g., USD)",
    value: t.currency
  }), e.length > 0 ? c(e) : g(t);
}
const R = new U({
  maxEntries: h.getConfig().cache.maxDurationEntries
});
function Z(i, e) {
  if (!i || typeof i != "object")
    return c({
      field: "items",
      message: `Breadcrumb item at index ${e} must be an object`,
      index: e
    });
  const t = i;
  if (!t.name || typeof t.name != "string" || !t.name.trim())
    return c({
      field: "name",
      message: `Breadcrumb item at index ${e} must have a non-empty name`,
      value: t.name,
      index: e
    });
  if (!t.url || typeof t.url != "string")
    return c({
      field: "url",
      message: `Breadcrumb item at index ${e} must have a valid URL`,
      value: t.url,
      index: e
    });
  const r = p(t.url.toString());
  if (!S(r))
    return c({
      field: "url",
      message: `Breadcrumb item at index ${e} has invalid URL format`,
      value: t.url,
      index: e
    });
  if (t.position !== void 0) {
    const s = Number(t.position);
    if (isNaN(s) || s < 1)
      return c({
        field: "position",
        message: `Breadcrumb item at index ${e} position must be a positive number`,
        value: t.position,
        index: e
      });
  }
  return g({
    name: o(t.name).trim(),
    url: r,
    position: t.position ? Number(t.position) : e + 1
  });
}
function X(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "items", message: "BreadcrumbList input must be an object" }]);
  const t = i;
  if (!t.items || !Array.isArray(t.items))
    return c([
      {
        field: "items",
        message: "BreadcrumbList must have an items array",
        value: t.items
      }
    ]);
  if (t.items.length === 0)
    return c([
      {
        field: "items",
        message: "BreadcrumbList must have at least one item",
        value: t.items
      }
    ]);
  const r = [];
  if (t.items.forEach((n, d) => {
    const f = Z(n, d);
    m(f) ? r.push(f.data) : e.push(f.error);
  }), e.length > 0)
    return c(e);
  const s = r.map((n) => n.position), a = s.filter((n, d) => s.indexOf(n) !== d);
  return a.length > 0 && e.push({
    field: "position",
    message: `Duplicate positions found: ${a.join(", ")}`,
    value: a
  }), e.length > 0 ? c(e) : g({
    items: r,
    name: t.name ? o(t.name) : void 0,
    description: t.description ? u(o(t.description)) : void 0
  });
}
class ee {
  constructor() {
    this.breadcrumbList = {
      "@type": "BreadcrumbList",
      itemListOrder: "ItemListOrderAscending"
    }, this.items = [];
  }
  addBreadcrumb(e, t, r) {
    if (!e || !t)
      throw new Error("Breadcrumb name and URL are required");
    const s = p(t), n = {
      "@type": "ListItem",
      position: r || this.items.length + 1,
      item: {
        "@type": "WebPage",
        "@id": s,
        name: o(e).trim(),
        url: s
      }
    };
    return this.items.push(n), this;
  }
  setName(e) {
    return e && (this.breadcrumbList.name = o(e).trim()), this;
  }
  setDescription(e) {
    return e && (this.breadcrumbList.description = u(o(e))), this;
  }
  build() {
    if (this.items.length === 0)
      throw new Error("BreadcrumbList must have at least one item");
    const e = [...this.items].sort((t, r) => t.position - r.position);
    return {
      ...this.breadcrumbList,
      numberOfItems: e.length,
      itemListElement: e
    };
  }
}
function te(i, e = {}) {
  const { useCache: t = !0, validateInput: r = !0 } = e, s = t ? JSON.stringify(i) : "";
  if (t && s) {
    const a = R.get(s);
    if (a)
      return l.debug("BreadcrumbList schema cache hit", { input: i }), g(a);
  }
  if (r) {
    const a = X(i);
    if (!m(a))
      return l.warn("Invalid BreadcrumbList input", { errors: a.error }), c(
        new Error(`Invalid BreadcrumbList input: ${a.error.map((n) => n.message).join(", ")}`)
      );
  }
  try {
    const a = new ee();
    i.name && a.setName(i.name), i.description && a.setDescription(i.description), i.items.forEach((d) => {
      a.addBreadcrumb(d.name, d.url, d.position);
    });
    const n = a.build();
    return t && s && R.set(s, n), l.info("Generated BreadcrumbList schema", {
      itemCount: i.items.length,
      hasName: !!i.name,
      hasDescription: !!i.description,
      cached: t
    }), g(n);
  } catch (a) {
    return l.error("Failed to generate BreadcrumbList schema", { error: a, input: i }), c(a instanceof Error ? a : new Error("Unknown error generating BreadcrumbList schema"));
  }
}
const T = new U({
  maxEntries: h.getConfig().cache.maxDurationEntries
});
function ie(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "contactType", message: "ContactPoint input must be an object" }]);
  const t = i;
  return (!t.contactType || typeof t.contactType != "string") && e.push({
    field: "contactType",
    message: "Contact type is required and must be a string",
    value: t.contactType
  }), t.email && typeof t.email == "string" && (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t.email) || e.push({
    field: "email",
    message: "Invalid email format",
    value: t.email
  })), t.url && typeof t.url == "string" && (S(t.url) || e.push({
    field: "url",
    message: "Invalid URL format",
    value: t.url
  })), t.availableLanguages !== void 0 && (Array.isArray(t.availableLanguages) ? t.availableLanguages.forEach((r, s) => {
    typeof r != "string" && e.push({
      field: "availableLanguages",
      message: `Language at index ${s} must be a string`,
      value: r
    });
  }) : e.push({
    field: "availableLanguages",
    message: "Available languages must be an array",
    value: t.availableLanguages
  })), e.length > 0 ? c(e) : g(t);
}
class re {
  constructor(e) {
    this.contactPoint = {
      "@type": "ContactPoint",
      contactType: u(o(e))
    };
  }
  setTelephone(e) {
    return e && (this.contactPoint.telephone = u(o(e))), this;
  }
  setEmail(e) {
    return e && (this.contactPoint.email = u(o(e))), this;
  }
  setFaxNumber(e) {
    return e && (this.contactPoint.faxNumber = u(o(e))), this;
  }
  setUrl(e) {
    return e && (this.contactPoint.url = u(o(e))), this;
  }
  setAreaServed(e) {
    return e && (this.contactPoint.areaServed = u(o(e))), this;
  }
  setAvailableLanguages(e) {
    return e && e.length > 0 && (this.contactPoint.availableLanguage = e.map((t) => u(o(t)))), this;
  }
  setHoursAvailable(e) {
    return e && l.debug("Skipping hoursAvailable - requires OpeningHoursSpecification parsing", { hours: e }), this;
  }
  setProductSupported(e) {
    return e && (this.contactPoint.productSupported = u(o(e))), this;
  }
  build() {
    if (!this.contactPoint.contactType)
      throw new Error("ContactPoint must have a contactType");
    return this.contactPoint;
  }
}
function se(i, e = {}) {
  const { useCache: t = !0, validateInput: r = !0 } = e, s = t ? JSON.stringify(i) : "";
  if (t && s) {
    const a = T.get(s);
    if (a)
      return l.debug("ContactPoint schema cache hit", { input: i }), g(a);
  }
  if (r) {
    const a = ie(i);
    if (!m(a))
      return l.warn("Invalid ContactPoint input", { errors: a.error }), c(new Error(`Invalid ContactPoint input: ${a.error.map((n) => n.message).join(", ")}`));
  }
  try {
    const n = new re(i.contactType).setTelephone(i.telephone).setEmail(i.email).setFaxNumber(i.faxNumber).setUrl(i.url).setAreaServed(i.areaServed).setAvailableLanguages(i.availableLanguages).setHoursAvailable(i.hoursAvailable).setProductSupported(i.productSupported).build();
    return t && s && T.set(s, n), l.info("Generated ContactPoint schema", {
      contactType: i.contactType,
      hasEmail: !!i.email,
      hasPhone: !!i.telephone,
      cached: t
    }), g(n);
  } catch (a) {
    return l.error("Failed to generate ContactPoint schema", { error: a, input: i }), c(a instanceof Error ? a : new Error("Unknown error generating ContactPoint schema"));
  }
}
const A = /* @__PURE__ */ new Map();
function ae(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "input", message: "Copyright input must be an object" }]);
  const t = i;
  if (!t.copyrightYear || typeof t.copyrightYear != "number")
    e.push({
      field: "copyrightYear",
      message: "Copyright year is required and must be a number",
      value: t.copyrightYear
    });
  else {
    const r = (/* @__PURE__ */ new Date()).getFullYear(), s = t.copyrightYear;
    (s < 1900 || s > r + 1) && e.push({
      field: "copyrightYear",
      message: `Copyright year must be between 1900 and ${r + 1}`,
      value: s
    });
  }
  if ((!t.copyrightHolder || typeof t.copyrightHolder != "string") && e.push({
    field: "copyrightHolder",
    message: "Copyright holder is required and must be a string",
    value: t.copyrightHolder
  }), t.licenseUrl && typeof t.licenseUrl == "string") {
    const r = p(t.licenseUrl);
    S(r) || e.push({
      field: "licenseUrl",
      message: "License URL must be a valid URL format",
      value: t.licenseUrl
    });
  }
  return t.licenseName && !t.licenseUrl && e.push({
    field: "licenseUrl",
    message: "License URL is required when license name is provided",
    value: t.licenseUrl
  }), e.length > 0 ? c(e) : g(t);
}
class ne {
  constructor() {
    this.schema = {
      "@type": "CreativeWork"
    };
  }
  setCopyrightYear(e) {
    return e && e > 0 && (this.schema.copyrightYear = e), this;
  }
  setCopyrightHolder(e) {
    return e && (e === "Storyblocks" ? this.schema.copyrightHolder = h.getOrganizationSchema() : this.schema.copyrightHolder = u(o(e))), this;
  }
  setCopyrightNotice(e) {
    return e && (this.schema.copyrightNotice = u(o(e))), this;
  }
  setLicense(e, t) {
    if (e)
      if (t) {
        const r = p(t);
        this.schema.license = {
          "@type": "CreativeWork",
          name: u(o(e)),
          url: r
        };
      } else
        this.schema.license = u(o(e));
    return this;
  }
  setUsageInfo(e) {
    return e && (this.schema.usageInfo = u(o(e))), this;
  }
  setAcquireLicensePage(e) {
    if (e) {
      const t = p(e);
      this.schema.acquireLicensePage = t;
    }
    return this;
  }
  build() {
    var e;
    if (!this.schema.copyrightYear)
      throw new Error("Copyright year is required");
    if (!this.schema.copyrightHolder)
      throw new Error("Copyright holder is required");
    if (!this.schema.copyrightNotice) {
      const t = typeof this.schema.copyrightHolder == "string" ? this.schema.copyrightHolder : ((e = this.schema.copyrightHolder) == null ? void 0 : e.name) ?? "Unknown";
      this.schema.copyrightNotice = `© ${this.schema.copyrightYear} ${t}. All rights reserved.`;
    }
    return this.schema;
  }
}
function oe(i, e = {}) {
  const t = `copyright-${JSON.stringify(i)}-${JSON.stringify(e)}`;
  if (!e.skipCache && A.has(t)) {
    const d = A.get(t);
    return l.debug("Retrieved copyright schema from cache", { cacheKey: t }), {
      schema: d,
      metadata: {
        generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        cacheHit: !0,
        validationPassed: !0
      }
    };
  }
  const r = ae(i);
  if (!m(r))
    return l.warn("Invalid copyright input", { errors: r.error }), {
      schema: {},
      metadata: {
        generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        cacheHit: !1,
        validationPassed: !1,
        errors: r.error
      }
    };
  const s = r.data, a = new ne();
  a.setCopyrightYear(s.copyrightYear).setCopyrightHolder(s.copyrightHolder), s.copyrightNotice && a.setCopyrightNotice(s.copyrightNotice), s.licenseName && a.setLicense(s.licenseName, s.licenseUrl), s.usageInfo && a.setUsageInfo(s.usageInfo);
  const n = a.build();
  return e.skipCache || A.set(t, n), l.info("Generated copyright schema", {
    year: n.copyrightYear,
    holder: typeof n.copyrightHolder == "string" ? n.copyrightHolder : "Organization",
    hasLicense: !!n.license
  }), {
    schema: n,
    metadata: {
      generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      cacheHit: !1,
      validationPassed: !0
    }
  };
}
const x = new U({
  maxEntries: h.getConfig().cache.maxDurationEntries
});
function B(i) {
  if (!i || typeof i != "object")
    return c({
      field: "searchUrl",
      message: "Search configuration must be an object"
    });
  const e = i;
  return !e.searchUrl || typeof e.searchUrl != "string" ? c({
    field: "searchUrl",
    message: "Search URL is required and must be a string",
    value: e.searchUrl
  }) : !e.queryParam || typeof e.queryParam != "string" ? c({
    field: "queryParam",
    message: "Query parameter name is required and must be a string",
    value: e.queryParam
  }) : g({
    searchUrl: o(e.searchUrl),
    queryParam: o(e.queryParam),
    name: e.name ? o(e.name) : void 0,
    description: e.description ? u(o(e.description)) : void 0
  });
}
function ce(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "name", message: "WebSite input must be an object" }]);
  const t = i;
  if ((!t.name || typeof t.name != "string" || !t.name.trim()) && e.push({
    field: "name",
    message: "Website name is required and must be a non-empty string",
    value: t.name
  }), !t.url || typeof t.url != "string" ? e.push({
    field: "url",
    message: "Website URL is required and must be a string",
    value: t.url
  }) : S(t.url.toString()) || e.push({
    field: "url",
    message: "Website URL must be a valid URL",
    value: t.url
  }), t.search) {
    const r = B(t.search);
    m(r) || e.push(r.error);
  }
  return e.length > 0 ? c(e) : g({
    name: o(t.name).trim(),
    url: o(t.url),
    description: t.description ? u(o(t.description)) : void 0,
    search: t.search ? (() => {
      const r = B(t.search);
      return m(r) ? r.data : void 0;
    })() : void 0,
    publisher: t.publisher ? o(t.publisher) : void 0
  });
}
class le {
  constructor(e, t) {
    this.website = {
      "@type": "WebSite",
      "@id": `${t}/#website`,
      name: o(e).trim(),
      url: o(t)
    };
  }
  setDescription(e) {
    return e && (this.website.description = u(o(e))), this;
  }
  setSearch(e, t) {
    if (e && t) {
      if (!this.website.url && !e.startsWith("http"))
        return l.warn("Cannot set search action without base URL for relative search URL", { searchUrl: e }), this;
      const r = this.website.url ?? "", a = {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${e.startsWith("http") ? e : `${r}${e}`}?${t}={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      };
      this.website.potentialAction = a;
    }
    return this;
  }
  setPublisher(e) {
    return e && (e === "Storyblocks" ? this.website.publisher = h.getOrganizationSchema() : this.website.publisher = {
      "@type": "Organization",
      name: o(e)
    }), this;
  }
  build() {
    if (!this.website.name || !this.website.url)
      throw new Error("WebSite must have name and URL");
    return this.website;
  }
}
function ue(i, e = {}) {
  const { useCache: t = !0, validateInput: r = !0 } = e, s = t ? JSON.stringify(i) : "";
  if (t && s) {
    const a = x.get(s);
    if (a)
      return l.debug("Enhanced WebSite schema cache hit", { input: i }), g(a);
  }
  if (r) {
    const a = ce(i);
    if (!m(a))
      return l.warn("Invalid enhanced WebSite input", { errors: a.error }), c(new Error(`Invalid WebSite input: ${a.error.map((n) => n.message).join(", ")}`));
  }
  try {
    const a = new le(i.name, i.url);
    i.description && a.setDescription(i.description), i.search && a.setSearch(i.search.searchUrl, i.search.queryParam), i.publisher && a.setPublisher(i.publisher);
    const n = a.build();
    return t && s && x.set(s, n), l.info("Generated enhanced WebSite schema", {
      name: i.name,
      url: i.url,
      hasSearch: !!i.search,
      hasPublisher: !!i.publisher,
      cached: t
    }), g(n);
  } catch (a) {
    return l.error("Failed to generate enhanced WebSite schema", { error: a, input: i }), c(a instanceof Error ? a : new Error("Unknown error generating WebSite schema"));
  }
}
const F = new U({
  maxEntries: h.getConfig().cache.maxDurationEntries
});
function de(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "title", message: "FAQ input must be an object" }]);
  const t = i;
  if ((!t.title || typeof t.title != "string") && e.push({
    field: "title",
    message: "Title is required and must be a string",
    value: t.title
  }), !t.questions || !Array.isArray(t.questions) ? e.push({
    field: "questions",
    message: "Questions array is required",
    value: t.questions
  }) : (t.questions.forEach((r, s) => {
    if (!r || typeof r != "object") {
      e.push({
        field: "questions",
        message: `Question at index ${s} must be an object`,
        value: r,
        questionIndex: s
      });
      return;
    }
    const a = r;
    (!a.question || typeof a.question != "string") && e.push({
      field: "question",
      message: `Question text is required at index ${s}`,
      value: a.question,
      questionIndex: s
    }), (!a.answer || typeof a.answer != "string") && e.push({
      field: "answer",
      message: `Answer text is required at index ${s}`,
      value: a.answer,
      questionIndex: s
    }), a.category !== void 0 && typeof a.category != "string" && e.push({
      field: "category",
      message: `Category must be a string at index ${s}`,
      value: a.category,
      questionIndex: s
    }), a.order !== void 0 && typeof a.order != "number" && e.push({
      field: "order",
      message: `Order must be a number at index ${s}`,
      value: a.order,
      questionIndex: s
    });
  }), t.questions.length === 0 && e.push({
    field: "questions",
    message: "At least one question is required",
    value: t.questions
  })), t.url && typeof t.url == "string" && (S(t.url) || e.push({
    field: "url",
    message: "Invalid URL format",
    value: t.url
  })), t.lastModified && typeof t.lastModified == "string") {
    const r = new Date(t.lastModified);
    isNaN(r.getTime()) && e.push({
      field: "lastModified",
      message: "Invalid date format for lastModified",
      value: t.lastModified
    });
  }
  return e.length > 0 ? c(e) : g(t);
}
class he {
  constructor(e) {
    this.faq = {
      "@type": "FAQPage",
      name: u(o(e)),
      mainEntity: []
    };
  }
  /**
   * Sets the description for the FAQ page.
   *
   * @param description - The description text
   * @returns This builder instance for chaining
   */
  setDescription(e) {
    return e && (this.faq.description = u(o(e))), this;
  }
  /**
   * Sets the URL and @id for the FAQ page.
   *
   * @param url - The URL of the FAQ page
   * @returns This builder instance for chaining
   */
  setUrl(e) {
    return e && (this.faq.url = u(o(e)), this.faq["@id"] = e), this;
  }
  /**
   * Sets the last modified date for the FAQ page.
   *
   * @param date - The last modified date string
   * @returns This builder instance for chaining
   */
  setLastModified(e) {
    if (e) {
      const t = new Date(e);
      isNaN(t.getTime()) || (this.faq.dateModified = t.toISOString());
    }
    return this;
  }
  /**
   * Sets the publisher organization for the FAQ page.
   *
   * @param publisher - The publisher organization name
   * @returns This builder instance for chaining
   */
  setPublisher(e) {
    return e && (this.faq.publisher = {
      "@type": "Organization",
      name: u(o(e))
    }), this;
  }
  /**
   * Sets the language for the FAQ page.
   *
   * @param language - The language code (e.g., 'en', 'es')
   * @returns This builder instance for chaining
   */
  setLanguage(e) {
    return e && (this.faq.inLanguage = u(o(e))), this;
  }
  /**
   * Adds a single question and answer to the FAQ.
   *
   * @param question - The question text
   * @param answer - The answer text
   * @param _category - Optional category (currently unused)
   * @returns This builder instance for chaining
   */
  addQuestion(e, t, r) {
    if (e && t) {
      const s = {
        "@type": "Question",
        name: u(o(e)),
        acceptedAnswer: {
          "@type": "Answer",
          text: u(o(t))
        }
      };
      this.faq.mainEntity = this.faq.mainEntity || [], this.faq.mainEntity.push(s);
    }
    return this;
  }
  /**
   * Adds multiple questions to the FAQ, sorted by order property.
   *
   * @param questions - Array of FAQ items to add
   * @returns This builder instance for chaining
   */
  addQuestions(e) {
    return [...e].sort((r, s) => r.order !== void 0 && s.order !== void 0 ? r.order - s.order : r.order !== void 0 ? -1 : s.order !== void 0 ? 1 : 0).forEach((r) => {
      this.addQuestion(r.question, r.answer, r.category);
    }), this;
  }
  /**
   * Builds and returns the complete FAQ schema object.
   *
   * @returns The constructed FAQ schema
   * @throws Error if required properties are missing
   */
  build() {
    if (!this.faq.name)
      throw new Error("FAQ must have a title");
    if (!this.faq.mainEntity || this.faq.mainEntity.length === 0)
      throw new Error("FAQ must have at least one question");
    return this.faq;
  }
}
function ge(i, e = {}) {
  const { useCache: t = !0, validateInput: r = !0 } = e, s = t ? JSON.stringify(i) : "";
  if (t && s) {
    const a = F.get(s);
    if (a)
      return l.debug("FAQ schema cache hit", { input: i }), g(a);
  }
  if (r) {
    const a = de(i);
    if (!m(a))
      return l.warn("Invalid FAQ input", { errors: a.error }), c(new Error(`Invalid FAQ input: ${a.error.map((n) => n.message).join(", ")}`));
  }
  try {
    const n = new he(i.title).setDescription(i.description).setUrl(i.url).setLastModified(i.lastModified).setPublisher(i.publisher || e.organizationName).setLanguage(i.inLanguage).addQuestions(i.questions).build();
    return t && s && F.set(s, n), l.info("Generated FAQ schema", {
      title: i.title,
      questionCount: i.questions.length,
      hasDescription: !!i.description,
      hasUrl: !!i.url,
      cached: t
    }), g(n);
  } catch (a) {
    return l.error("Failed to generate FAQ schema", { error: a, input: i }), c(a instanceof Error ? a : new Error("Unknown error generating FAQ schema"));
  }
}
const _ = (i) => {
  i["@type"] || l.warn("Generated schema object missing required @type property", { schema: i }), (i["@type"] === "Product" || i["@type"] === "Service" || i["@type"] === "Article" || i["@type"] === "CreativeWork" ? i.name : void 0) || l.warn(`${i["@type"]} schema missing required name property`, { schema: i });
}, z = (i) => i === "Storyblocks" ? h.getOrganizationSchema() : i ? {
  "@type": "Organization",
  name: i
} : void 0, fe = (i) => i === "Storyblocks" ? h.getOrganizationSchema() : i ? {
  "@type": "Organization",
  name: i
} : void 0;
class $ {
  constructor(e, t) {
    this.schema = {
      "@type": e,
      name: o(t)
    };
  }
  addDescription(e) {
    return e && (this.schema.description = u(e)), this;
  }
  addImage(e) {
    return e && (this.schema.image = e), this;
  }
  addUrl(e) {
    return e && (this.schema.url = e), this;
  }
  addOffer(e, t) {
    return e && t && (this.schema.offers = {
      "@type": "Offer",
      price: o(e),
      priceCurrency: o(t).toUpperCase()
    }), this;
  }
  validate() {
    return _(this.schema), this;
  }
  build() {
    return this.schema;
  }
}
const me = (i) => {
  const e = E(i);
  if (!m(e))
    return l.warn("Invalid product input", { errors: e.error }), c(new Error("Invalid product input"));
  const r = new $("Product", i.title).addDescription(i.description).addImage(i.image).addUrl(i.url).addOffer(i.price, i.currency).validate().build();
  return g(r);
}, pe = (i, e) => {
  const t = E(i);
  if (!m(t))
    return l.warn("Invalid service input", { errors: t.error }), c(new Error("Invalid service input"));
  const s = new $("Service", i.title).addDescription(i.description).addImage(i.image).addUrl(i.url).addOffer(i.price, i.currency).validate().build(), a = z(e);
  return a && (s.provider = a), g(s);
}, be = (i, e) => {
  const t = E(i);
  if (!m(t))
    return l.warn("Invalid article input", { errors: t.error }), c(new Error("Invalid article input"));
  const r = {
    "@type": "Article",
    name: o(i.title),
    headline: o(i.headline || i.title),
    ...i.description && { description: u(i.description) },
    ...i.image && { image: i.image },
    ...i.url && { url: i.url }
  }, s = fe(e);
  return s && (r.publisher = s), _(r), g(r);
}, ve = (i, e) => {
  const t = E(i);
  if (!m(t))
    return l.warn("Invalid creative work input", { errors: t.error }), c(new Error("Invalid creative work input"));
  const s = new $("CreativeWork", i.title).addDescription(i.description).addImage(i.image).addUrl(i.url).validate().build(), a = z(e);
  return a && (s.creator = a), g(s);
}, ye = (i, e, t) => {
  switch (i) {
    case "product":
      return me(e);
    case "service":
      return pe(e, t);
    case "article":
      return be(e, t);
    case "creative-work":
      return ve(e, t);
    default: {
      const r = new Error(`Unsupported schema type: ${i}`);
      return l.error("Unsupported schema type", { schemaType: i }), c(r);
    }
  }
}, we = (i) => {
  const { schemaType: e, heading: t, description: r, items: s, url: a, organizationName: n } = i;
  if (!(s != null && s.length))
    return l.debug("No items provided for ItemList schema generation"), null;
  const d = [], f = [];
  if (s.forEach((I, O) => {
    const w = ye(e, I, n);
    m(w) ? d.push(w.data) : (f.push({ index: O, error: w.error }), l.warn(`Failed to generate schema for item at index ${O}`, {
      schemaType: e,
      error: w.error
    }));
  }), d.length === 0)
    return l.error("Failed to generate any valid schema items", {
      totalItems: s.length,
      errors: f
    }), null;
  const L = {
    "@type": "ItemList",
    name: o(t),
    ...r && { description: u(r) },
    numberOfItems: d.length,
    ...a && { url: a },
    itemListElement: d
  };
  return l.info("Generated ItemList schema", {
    schemaType: e,
    itemCount: d.length,
    skippedCount: f.length,
    hasUrl: !!a,
    organizationName: n
  }), L;
}, q = /* @__PURE__ */ new Map();
function Se(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "input", message: "Legal document input must be an object" }]);
  const t = i;
  if ((!t.title || typeof t.title != "string") && e.push({ field: "title", message: "Title is required and must be a string", value: t.title }), !t.url || typeof t.url != "string")
    e.push({ field: "url", message: "URL is required and must be a string", value: t.url });
  else {
    const s = p(t.url);
    S(s) || e.push({ field: "url", message: "URL must be a valid URL format", value: t.url });
  }
  const r = ["datePublished", "dateModified", "effectiveDate"];
  for (const s of r) {
    const a = t[s];
    if (a && typeof a == "string") {
      const n = new Date(a);
      isNaN(n.getTime()) && e.push({ field: s, message: "Date must be in valid ISO format", value: a });
    }
  }
  return t.language && typeof t.language == "string" && (t.language.length < 2 || t.language.length > 5) && e.push({
    field: "language",
    message: 'Language must be a valid language code (e.g., "en", "en-US")',
    value: t.language
  }), e.length > 0 ? c(e) : g(t);
}
function W(i, e) {
  if (!i.about)
    i.about = {
      "@type": "Thing",
      name: "Legal Document",
      description: e
    };
  else if (typeof i.about == "object" && i.about !== null && "@type" in i.about) {
    const t = i.about, r = typeof t.description == "string" ? t.description : "Legal document";
    t.description = `${r}. ${e}`;
  }
}
class Ie {
  constructor(e, t) {
    const r = p(t);
    this.schema = {
      "@type": "WebPage",
      "@id": `${r}#webpage`,
      name: u(o(e)),
      url: r
    };
  }
  setTitle(e) {
    return this.schema.name = u(o(e)), this;
  }
  setUrl(e) {
    const t = p(e);
    return this.schema.url = t, this.schema["@id"] = `${t}#webpage`, this;
  }
  setDatePublished(e) {
    const t = new Date(e);
    return isNaN(t.getTime()) || (this.schema.datePublished = t.toISOString()), this;
  }
  setDateModified(e) {
    const t = new Date(e);
    return isNaN(t.getTime()) || (this.schema.dateModified = t.toISOString()), this;
  }
  setEffectiveDate(e) {
    const t = new Date(e);
    return isNaN(t.getTime()) || W(this.schema, `Effective from ${t.toISOString()}`), this;
  }
  setJurisdiction(e) {
    const t = u(o(e));
    return W(this.schema, `Under ${t} jurisdiction`), this;
  }
  setPublisher(e) {
    return e === "Storyblocks" ? this.schema.publisher = h.getOrganizationSchema() : this.schema.publisher = {
      "@type": "Organization",
      name: u(o(e))
    }, this;
  }
  setDescription(e) {
    return this.schema.description = u(o(e)), this;
  }
  setLanguage(e) {
    return this.schema.inLanguage = o(e), this;
  }
  build() {
    return this.schema.publisher || (this.schema.publisher = h.getOrganizationSchema()), this.schema;
  }
}
function Ce(i, e = {}) {
  const t = `legal-${JSON.stringify(i)}-${JSON.stringify(e)}`;
  if (!e.skipCache && q.has(t)) {
    const d = q.get(t);
    return l.debug("Retrieved legal document schema from cache", { cacheKey: t }), {
      schema: d,
      metadata: {
        generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        cacheHit: !0,
        validationPassed: !0
      }
    };
  }
  const r = Se(i);
  if (!m(r))
    return l.warn("Invalid legal document input", { errors: r.error }), {
      schema: {},
      metadata: {
        generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        cacheHit: !1,
        validationPassed: !1,
        errors: r.error
      }
    };
  const s = r.data, a = new Ie(s.title, s.url);
  s.datePublished && a.setDatePublished(s.datePublished), s.dateModified && a.setDateModified(s.dateModified), s.effectiveDate && a.setEffectiveDate(s.effectiveDate), s.jurisdiction && a.setJurisdiction(s.jurisdiction), s.publisher && a.setPublisher(s.publisher), s.description && a.setDescription(s.description), s.language && a.setLanguage(s.language);
  const n = a.build();
  return e.skipCache || q.set(t, n), l.info("Generated legal document schema", {
    title: n.name,
    url: n.url,
    hasPublisher: !!n.publisher
  }), {
    schema: n,
    metadata: {
      generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      cacheHit: !1,
      validationPassed: !0
    }
  };
}
const N = /* @__PURE__ */ new Map();
function Ue(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "input", message: "Navigation item input must be an object" }]);
  const t = i;
  if ((!t.name || typeof t.name != "string") && e.push({ field: "name", message: "Name is required and must be a string", value: t.name }), !t.url || typeof t.url != "string")
    e.push({ field: "url", message: "URL is required and must be a string", value: t.url });
  else {
    const r = p(t.url);
    S(r) || e.push({ field: "url", message: "URL must be a valid URL format", value: t.url });
  }
  return t.position !== void 0 && (typeof t.position != "number" || t.position < 1) && e.push({ field: "position", message: "Position must be a positive number", value: t.position }), e.length > 0 ? c(e) : g(t);
}
function Le(i) {
  const e = [];
  if (!i || typeof i != "object")
    return c([{ field: "input", message: "Site navigation input must be an object" }]);
  const t = i;
  return !t.items || !Array.isArray(t.items) ? c([{ field: "items", message: "Items must be an array" }]) : t.items.length === 0 ? c([{ field: "items", message: "At least one navigation item is required" }]) : (t.items.forEach((r, s) => {
    const a = Ue(r);
    m(a) || a.error.forEach((n) => {
      e.push({
        field: `items[${s}].${n.field}`,
        message: n.message,
        value: n.value
      });
    });
  }), e.length > 0 ? c(e) : g(t));
}
class Pe {
  constructor() {
    this.schema = {
      "@type": "SiteNavigationElement"
    }, this.items = [];
  }
  addNavigationItem(e, t, r) {
    const s = p(t), a = {
      "@type": "SiteNavigationElement",
      name: u(o(e)),
      url: s
    };
    return r !== void 0 && r > 0 && (a.position = r), this.items.push(a), this;
  }
  setName(e) {
    return this.schema.name = u(o(e)), this;
  }
  setDescription(e) {
    return this.schema.description = u(o(e)), this;
  }
  build() {
    const e = this.items.sort((t, r) => {
      const s = Number(t.position) || 999, a = Number(r.position) || 999;
      return s - a;
    });
    return this.schema.name || (this.schema.name = "Site Navigation"), {
      ...this.schema,
      hasPart: e
    };
  }
}
function Oe(i, e = {}) {
  var d;
  const t = `navigation-${JSON.stringify(i)}-${JSON.stringify(e)}`;
  if (!e.skipCache && N.has(t)) {
    const f = N.get(t);
    return l.debug("Retrieved site navigation schema from cache", { cacheKey: t }), {
      schema: f,
      metadata: {
        generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        cacheHit: !0,
        validationPassed: !0
      }
    };
  }
  const r = Le(i);
  if (!m(r))
    return l.warn("Invalid site navigation input", { errors: r.error }), {
      schema: {},
      metadata: {
        generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
        cacheHit: !1,
        validationPassed: !1,
        errors: r.error
      }
    };
  const s = r.data, a = new Pe();
  s.name && a.setName(s.name), s.description && a.setDescription(s.description), s.items.forEach((f) => {
    a.addNavigationItem(f.name, f.url, f.position);
  });
  const n = a.build();
  return e.skipCache || N.set(t, n), l.info("Generated site navigation schema", {
    name: n.name,
    itemCount: ((d = n.hasPart) == null ? void 0 : d.length) || 0
  }), {
    schema: n,
    metadata: {
      generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
      cacheHit: !1,
      validationPassed: !0
    }
  };
}
const H = new U({
  maxEntries: h.getConfig().cache.maxVideoEntries,
  ttl: h.getConfig().cache.ttl
}), Ee = new J(), Ae = (i) => {
  const e = {
    encodingFormat: "video/mp4"
  };
  if (i.maxResolution) {
    const t = y(i.maxResolution);
    if (e.videoQuality = `${t}p`, e.height = `${t}px`, i.aspectRatio) {
      const r = y(i.aspectRatio, 1.7777777777777777);
      e.width = `${Math.round(t * r)}px`;
    } else
      e.width = `${Math.round(t * (16 / 9))}px`;
  }
  return i.fileSize && (e.contentSize = `${y(i.fileSize)}MB`), i.bitrate && (e.bitrate = `${y(i.bitrate)}kbps`), e;
}, qe = (i) => {
  const e = h.getConfig();
  return {
    license: h.buildUrl(e.storyblocks.endpoints.pricing),
    acquireLicensePage: i.detailsUrl ? p(i.detailsUrl) : void 0,
    isAccessibleForFree: !1,
    offers: {
      "@type": "Offer",
      category: "Subscription",
      businessFunction: {
        "@type": "BusinessFunction",
        "@id": "http://purl.org/goodrelations/v1#LeaseOut"
      },
      seller: h.getOrganizationSchema(),
      url: h.buildUrl(e.storyblocks.endpoints.pricing),
      description: "Individual license, higher quality stock content and more."
    }
  };
}, Ne = (i) => {
  const e = {};
  if (i.viewCount) {
    const r = {
      "@type": "InteractionCounter",
      "@id": "https://schema.org/WatchAction",
      interactionType: {
        "@type": "Action",
        "@id": "https://schema.org/WatchAction"
      },
      userInteractionCount: y(i.viewCount)
    };
    e.interactionStatistic = [r];
  }
  if (i.downloadCount) {
    const r = {
      "@type": "InteractionCounter",
      "@id": "https://schema.org/DownloadAction",
      interactionType: {
        "@type": "Action",
        "@id": "https://schema.org/DownloadAction"
      },
      userInteractionCount: y(i.downloadCount)
    };
    e.interactionStatistic ? Array.isArray(e.interactionStatistic) ? e.interactionStatistic.push(r) : e.interactionStatistic = [e.interactionStatistic, r] : e.interactionStatistic = [r];
  }
  const t = h.getConfig().validation;
  if (i.rating && i.ratingCount) {
    const r = {
      "@type": "AggregateRating",
      ratingValue: y(i.rating),
      ratingCount: y(i.ratingCount),
      bestRating: t.maxRating,
      worstRating: t.minRating
    };
    e.aggregateRating = r;
  }
  return e;
};
class $e {
  constructor(e, t) {
    this.videoItem = e, this.index = t, this.videoObject = {}, this.config = h.getConfig(), this.initializeBasicInfo();
  }
  initializeBasicInfo() {
    const e = `Video ${this.index + 1}`;
    return this.videoObject = {
      "@type": "VideoObject",
      "@id": `#video-${this.videoItem.id || this.index}`,
      name: o(this.videoItem.title, e),
      description: o(
        this.videoItem.description,
        `${this.videoItem.title || e} - Royalty-free stock video from Storyblocks`
      ),
      thumbnailUrl: this.videoItem.thumbnailUrl || this.videoItem.mediumImageUrl || this.videoItem.largeImageUrl,
      uploadDate: this.videoItem.dateAdded || (/* @__PURE__ */ new Date()).toISOString(),
      url: this.videoItem.detailsUrl ? p(this.videoItem.detailsUrl) : void 0,
      embedUrl: this.videoItem.previewUrl,
      contentUrl: this.videoItem.previewUrl,
      publisher: h.getOrganizationSchema()
    }, this;
  }
  addDuration() {
    return this.videoItem.duration && (this.videoObject.duration = Ee.convertToIsoDuration(y(this.videoItem.duration))), this;
  }
  addCategories() {
    var e;
    if ((e = this.videoItem.categories) != null && e.length) {
      const t = this.videoItem.categories.map((r) => r.name);
      this.videoObject.keywords = t.join(", "), this.videoObject.genre = t, this.videoObject.about = {
        "@type": "Thing",
        name: t.join(", "),
        url: h.buildUrl(`/video/search/${encodeURIComponent(t.join(", "))}`)
      };
    }
    return this;
  }
  addContributor() {
    var e;
    return (e = this.videoItem.contributor) != null && e.username && (this.videoObject.creator = {
      "@type": "Person",
      name: this.videoItem.contributor.username,
      url: h.buildUrl(`/video/portfolio/${this.videoItem.contributor.username}`),
      ...this.videoItem.contributor.profileImageUrl && {
        image: this.videoItem.contributor.profileImageUrl
      }
    }), this;
  }
  addFormatInfo() {
    return Object.assign(this.videoObject, Ae(this.videoItem)), this;
  }
  addPricingInfo() {
    return Object.assign(this.videoObject, qe(this.videoItem)), this;
  }
  addInteractionStats() {
    return Object.assign(this.videoObject, Ne(this.videoItem)), this;
  }
  addMetadata() {
    var e;
    return (e = this.videoItem.tags) != null && e.length && (this.videoObject.contentTags = this.videoItem.tags), this.videoItem.language && (this.videoObject.inLanguage = this.videoItem.language), this.videoObject.potentialAction = [
      {
        "@type": "WatchAction",
        target: this.videoItem.previewUrl,
        name: "Preview Video"
      },
      {
        "@type": "DownloadAction",
        target: this.videoItem.detailsUrl ? p(this.videoItem.detailsUrl) : void 0,
        name: "Download Video"
      },
      {
        "@type": "ShareAction",
        target: this.videoItem.detailsUrl ? p(this.videoItem.detailsUrl) : void 0,
        name: "Share Video"
      }
    ].filter((t) => t.target), this.videoItem.hasClosedCaptions && (this.videoObject.accessibilityFeature = ["closedCaptions"]), this;
  }
  build() {
    return this.videoObject;
  }
}
const De = (i, e) => {
  const t = K(i);
  if (!m(t))
    return l.warn("Invalid video item", { errors: t.error }), c(new Error("Invalid video item"));
  const r = i.dateModified || i.dateAdded, s = `${i.id}-${r}`, a = H.get(s);
  if (a)
    return g(a);
  const d = new $e(i, e).addDuration().addCategories().addContributor().addFormatInfo().addPricingInfo().addInteractionStats().addMetadata().build();
  return H.set(s, d), g(d);
}, je = ({
  heading: i,
  description: e,
  videos: t,
  pageUrl: r,
  contentMode: s,
  category: a,
  searchTerm: n,
  totalResults: d,
  currentPage: f,
  itemsPerPage: L
}) => {
  if (!(t != null && t.length))
    return l.debug("No videos provided for schema generation"), "";
  const I = t.filter((b) => {
    var v;
    return (v = b == null ? void 0 : b.stockItem) == null ? void 0 : v.id;
  });
  if (I.length === 0)
    return l.warn("No valid videos found for schema generation"), "";
  const O = () => {
    if (e) return e;
    const b = d || t.length, v = `Browse ${b.toLocaleString()} royalty-free video${b === 1 ? "" : "s"}`;
    return n ? `${v} for "${n}" on Storyblocks. High-quality stock footage for your creative projects.` : a ? `${v} in the ${a} category on Storyblocks. Professional stock video content.` : `${v} on Storyblocks. Premium stock video library for creators.`;
  }, w = [];
  if (I.forEach((b, v) => {
    const j = De(b.stockItem, v);
    m(j) ? w.push(j.data) : l.warn(`Failed to create video object for index ${v}`, {
      videoId: b.stockItem.id
    });
  }), w.length === 0)
    return l.error("Failed to create any valid video objects"), "";
  const D = h.getConfig(), C = {
    "@context": "https://schema.org",
    "@type": s === "collection" ? "VideoGallery" : "ItemList",
    name: i,
    description: O(),
    numberOfItems: d || I.length,
    publisher: h.getOrganizationSchema(),
    itemListElement: w.map((b, v) => ({
      "@type": "ListItem",
      position: (f ? (f - 1) * (L || I.length) : 0) + v + 1,
      item: b
    }))
  };
  return r && (C.url = r), f && L && d && Math.ceil(d / L) > 1 && (C.mainEntity = {
    "@type": "CollectionPage",
    isPartOf: {
      "@type": "ItemList",
      numberOfItems: d
    }
  }), s === "search" && (a || n) && (C.about = {
    "@type": "Thing",
    name: n || a,
    description: `Professional video content related to ${n || a}`,
    sameAs: a ? h.buildUrl(`/video/search/${encodeURIComponent(a)}`) : void 0
  }), a && (C.breadcrumb = {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: D.storyblocks.baseUrl
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Videos",
        item: h.buildUrl(D.storyblocks.endpoints.video)
      },
      {
        "@type": "ListItem",
        position: 3,
        name: a,
        item: h.buildUrl(`/video/search/${encodeURIComponent(a)}`)
      }
    ]
  }), C.isPartOf = h.getWebsiteSchema(), l.info("Generated video collection schema", {
    videoCount: w.length,
    contentMode: s,
    hasCategory: !!a,
    hasSearchTerm: !!n
  }), JSON.stringify(C, null, 0);
}, Be = {
  CONTACT_POINT: "contactPoint",
  BREADCRUMB_LIST: "breadcrumbList",
  ENHANCED_WEBSITE: "enhancedWebsite",
  ITEM_LIST: "itemList",
  VIDEO_COLLECTION: "videoCollection",
  LEGAL_DOCUMENT: "legalDocument",
  SITE_NAVIGATION: "siteNavigation",
  COPYRIGHT: "copyright",
  FAQ: "faq"
};
function ke(i, e, t) {
  switch (i) {
    case "contactPoint":
      return se(e, t);
    case "breadcrumbList":
      return te(e, t);
    case "enhancedWebsite":
      return ue(e, t);
    case "itemList":
      return we(e);
    case "videoCollection": {
      const r = je(
        e
      );
      if (r && typeof r == "string")
        try {
          return JSON.parse(r);
        } catch {
          return null;
        }
      return null;
    }
    case "legalDocument": {
      const r = Ce(e, t);
      return r && typeof r == "object" && "schema" in r ? g(r.schema) : c(new Error("Invalid legal document result"));
    }
    case "siteNavigation": {
      const r = Oe(e, t);
      return r && typeof r == "object" && "schema" in r ? g(r.schema) : c(new Error("Invalid site navigation result"));
    }
    case "copyright": {
      const r = oe(e, t);
      return r && typeof r == "object" && "schema" in r ? g(r.schema) : c(new Error("Invalid copyright result"));
    }
    case "faq":
      return ge(e, t);
    default:
      throw new Error(`Unsupported schema type: ${i}`);
  }
}
function Fe(i, e) {
  const t = {};
  for (const [r, s] of Object.entries(i))
    try {
      t[r] = ke(
        s.type,
        s.input,
        e
      );
    } catch (a) {
      t[r] = c(
        a instanceof Error ? a : new Error(`Failed to generate schema for ${r}`)
      );
    }
  return t;
}
export {
  Be as SCHEMA_TYPES,
  h as config,
  ke as generateSchema,
  Fe as generateSchemas,
  xe as resetConfig,
  Te as updateConfig
};
